import { version } from '../version.js';
export const turboCliTags = [
    { name: 'App-Name', value: 'Turbo-CLI' },
    { name: 'App-Version', value: version },
    { name: 'App-Platform', value: process.platform },
];
export const wincPerCredit = 1_000_000_000_000;
export const defaultProdGatewayUrls = {
    arweave: 'https://arweave.net',
    solana: 'https://api.mainnet-beta.solana.com',
    ethereum: 'https://cloudflare-eth.com/',
    'base-eth': 'https://mainnet.base.org',
    kyve: 'https://api.kyve.network/',
    matic: 'https://polygon-rpc.com/',
    pol: 'https://polygon-rpc.com/',
};
